import React, { lazy } from "react"
import { Route, Switch } from "react-router-dom"

// region ##   C O M P O N E N T s
import AdminRoute from "./component/route/AdminRoute"
import LoggedInRoute from "./component/route/LoggedInRoute"
import LoggedOutRoute from "./component/route/LoggedOutRoute"
import withContainer from "./commons/withContainer"
import withNavBreadcrumbs from "./pages/admin/withNavBreadcrumbs"
// endregion
// region ##   P U B L I C   P A G E s
import LoginPage from "./pages/login/LoginPage"
import FirstUserConnectionPage from "./pages/user/FirstUserConnectionPage"
import AddOrEditUserPage from "./pages/user/AddOrEditUserPage"
import ChangePasswordPage from "./pages/user/ChangePasswordPage"
import RegisterConfirmPage from "./pages/user/RegisterConfirmPage"
import DocumentsPage from "./pages/document/DocumentsPage"
import DocumentsStatementPage from "./pages/document/DocumentsStatementPage"
import DocumentsFormsPage from "./pages/document/DocumentsFormsPage"
import CustomUserFormPage from "./pages/forms/CustomUserFormPage"
import SigningCeremonyPage from "./pages/document/SigningCeremonyPage"
import appConfig from "./AppConfig"
import UnsubscriptionConfirmationPage from "./pages/user/UnsubscriptionConfirmationPage"
// endregion
// region ##    M O D U L E s   P A G E s  ## (React lazy components declaration)
const FundsRouter = lazy(() => import("./pages/assetmanagement/FundRouter"))
const PageNotFound = lazy(() => import("./pages/PageNotFound"))
const AdminRouter = lazy(() => import("./pages/admin/AdminRouter"))
const WealthRouter = lazy(() => import("./pages/wealth/WealthRouter"))
// endregion

/**
 * Main website router. It does lazy loading when asking for sub module (aka: admin, wealth).
 *
 * @returns {JSX.Element}
 * @constructor
 */
export default function AppRouter() {
  return (
    <Switch>
      <Route component={UnsubscriptionConfirmationPage} path="/unsubscribe" />
      <LoggedOutRoute component={LoginPage} path="/login" />
      <LoggedOutRoute
        component={FirstUserConnectionPage}
        childProps={{ needsToken: true }}
        path="/register/:token"
      />
      <LoggedOutRoute
        component={withContainer(RegisterConfirmPage)}
        path="/register-confirmation"
      />
      <LoggedOutRoute
        component={withContainer(ChangePasswordPage)}
        childProps={{ needsToken: true }}
        path="/reset-password/:token"
      />
      {appConfig.showAssetManagementPage && (
        <Route path="/am" component={FundsRouter} />
      )}
      <LoggedInRoute path="/wealth" lazyComponent={() => WealthRouter} />
      <AdminRoute path="/admin" lazyComponent={() => AdminRouter} />
      <LoggedInRoute
        component={withContainer(AddOrEditUserPage)}
        exact
        path="/user"
      />
      <LoggedInRoute
        component={withContainer(AddOrEditUserPage)}
        path="/user/:id"
      />
      <LoggedInRoute
        component={withContainer(ChangePasswordPage)}
        path="/change-password/:id"
      />
      <LoggedInRoute
        component={withNavBreadcrumbs(DocumentsPage)}
        exact
        path="/documents"
      />
      <LoggedInRoute
        component={withNavBreadcrumbs(DocumentsFormsPage)}
        exact
        path="/documents/forms"
      />
      <LoggedInRoute
        component={withNavBreadcrumbs(DocumentsStatementPage)}
        exact
        path="/documents/statements"
      />
      <LoggedInRoute
        component={withContainer(CustomUserFormPage)}
        exact
        path="/form/:id"
      />
      <LoggedInRoute
        component={withContainer(SigningCeremonyPage)}
        exact
        path="/esign/:id"
      />
      {/* DEFAULT PAGE
      -> When logged in then show a nice 404 not found page
      -> When not logged in then show LoginPage

      This works properly while we do not provide any public page.
   */}
      <AdminRoute path="/" lazyComponent={() => AdminRouter} />
      <Route lazyComponent={() => withContainer(PageNotFound)} />
    </Switch>
  )
}
